
import CartPreview from '@features/cart/ui/preview'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface CartModalProps {
  className?: string;
  onClose?: () => void;
}

export default function CartModal ({ className, onClose }: CartModalProps) {
  return (
    <div className={cn(styles.cartModal, className)}>
      <CartPreview onClose={onClose} />
    </div>
  )
}
